import React from 'react';
import CategoriesGrid from '../components/CategoriesGrid';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const CategoriesAll = () => (
  <div>
    <div className="max-w-7xl mx-auto px-4 pt-6">
      <nav className="flex items-center gap-1.5 text-sm text-[#7A6F5C]">
        <Link to="/" className="hover:text-[#1F4D3F]">Accueil</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-[#2D2A26]">Toutes les catégories</span>
      </nav>
    </div>
    <CategoriesGrid />
  </div>
);

export default CategoriesAll;
